import React from "react";
import PropTypes from "prop-types";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "gatsby";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import "../styles/components/CTACards.scss";

const CTACards = ({ cards }) => {
    if (!cards.length) {
        return null;
    }

    return (
        <Row className="cta-cards">
            {cards.map(card => (
                <Col
                    className="mb-2 mb-md-3 mb-lg-0"
                    md="auto"
                    lg={6}
                    key={card.link}
                >
                    <Row className="cta-card">
                        <Col className="text-center mb-2 mb-lg-0" md={3}>
                            <GatsbyImageWithSVGSupport image={card.image} />
                        </Col>
                        <Col className="text-center text-lg-start">
                            <h3>{card.title}</h3>
                            <Button as={Link} to={card.link} size="lg">
                                {card.linkText}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            ))}
        </Row>
    );
};

CTACards.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            image: PropTypes.shape({ gatsbyImageData: PropTypes.object })
                .isRequired,
            linkText: PropTypes.string,
            link: PropTypes.string,
        })
    ),
};

export default CTACards;
